import { Action, combineReducers, configureStore, ThunkAction } from '@reduxjs/toolkit';
import { globalSlice, GlobalState } from './slices';
import { issueVcSlice, IssueVcState } from './slices/issuevc';
import { DemoCredential, demoCredentialSlice, DemoCredentialState } from './slices/democredential';
import { playgroundSlice, PlaygroundState } from './slices/playground';


export interface ApplicationState {
    globalState: GlobalState;
    demoCredentialState: DemoCredentialState;
    issueVcState: IssueVcState;
    playgroundState: PlaygroundState;
}

const rootReducer = combineReducers<ApplicationState>({
    globalState: globalSlice.reducer,
    demoCredentialState: demoCredentialSlice.reducer,
    issueVcState: issueVcSlice.reducer,
    playgroundState: playgroundSlice.reducer

});
export const store = configureStore({
    reducer: rootReducer
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;
